import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { func, string, arrayOf } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { selectContentForms } from '@redux/forms/reducers';
import { fetchForms } from '@redux/forms/actions';
import createColumns from './createFormColumns';
import ContentModal from './Modal';
import { FEATURE_FORM, whatTypeToTranslationKey } from '../../../../../../constants';
import './style.less';

const filterFunc = (value, comparator) => {
  return comparator(value.name) || comparator(value.description);
};

function SelectFormModal({ defaultFilteredValue, onCancel, onOk, audienceTypesToFilter }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, forms] = useSelector(selectContentForms);
  const contentTypeTranslationKey = whatTypeToTranslationKey(FEATURE_FORM);
  const columns = useMemo(() => createColumns(t, defaultFilteredValue, contentTypeTranslationKey), [
    defaultFilteredValue,
    t,
    contentTypeTranslationKey,
  ]);

  useEffect(() => {
    dispatch(fetchForms());
  }, [dispatch]);

  return (
    <ContentModal
      columns={columns}
      data={forms.filter(form => !audienceTypesToFilter.includes(form.audienceType))}
      loading={loading}
      title={t('pathways:ProcedureRules.wizard.content.form')}
      filterFunc={filterFunc}
      onCancel={onCancel}
      onOk={onOk}
    />
  );
}

SelectFormModal.propTypes = {
  onCancel: func.isRequired,
  onOk: func.isRequired,
  audienceTypesToFilter: arrayOf(string),
};

SelectFormModal.defaultProps = {
  audienceTypesToFilter: [],
};

export default SelectFormModal;
